<h2 *ngIf="tenantForm.get('name')?.value" mat-dialog-title class="modal-header">
  {{ "master-tenant.edit" | translate }}: {{ tenantForm.get("name")?.value }}
  <button mat-icon-button class="close-button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<h2
  *ngIf="!tenantForm.get('name')?.value"
  mat-dialog-title
  class="modal-header"
>
  {{ "master-tenant.new" | translate }}
  <button mat-icon-button class="close-button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="modal-content">
  <form [formGroup]="tenantForm" class="tenant-form">
    <table class="tenant-table">
      <thead>
        <tr>
          <th>{{ "master-tenant.tenantName" | translate }}</th>
          <th *ngIf="platformId == 'mx'">
            {{ "master-tenant.tenantAka" | translate }}
          </th>
          <th *ngIf="platformId == 'mx'">
            {{ "master-tenant.parentCompany" | translate }}
          </th>
          <th *ngIf="platformId == 'br'">
            {{ "master-tenant.industry" | translate }}
          </th>
          <th *ngIf="platformId == 'br'">
            {{ "master-tenant.country" | translate }}
          </th>
          <th *ngIf="platformId == 'br'">
            {{ "master-tenant.website" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <input
              matInput
              formControlName="name"
              class="table-input form-control"
            />
          </td>
          <td *ngIf="platformId == 'mx'">
            <input
              matInput
              formControlName="aka"
              class="table-input form-control"
            />
          </td>
          <td *ngIf="platformId == 'mx'">
            <div
              style="text-align: start; width: 100%;"
              (click)="dropdownClicked = true"
            >
              <input
                type="text"
                [value]="parentCorporationNameValue"
                (input)="onInputChange($event)"
                (focus)="isDropdownOpen = true"
                placeholder="Type to search..."
                [ngClass]="{ loading: isLoading }"
                style="width: 100%; text-align: left;"
                class="form-control tenant-input"
              />
              <span *ngIf="isLoading" class="loading-icon">🔄</span>
              <ul
                *ngIf="tenantsList.length && isDropdownOpen && !isLoading"
                class="autocomplete-dropdown"
                [ngValue]="parentCorporation"
              >
                <li
                  *ngFor="let option of tenantsList"
                  (click)="onSelectOption(option)"
                  style="text-align: left; padding: 8px; cursor: pointer;"
                >
                  {{ option.name }}
                </li>
              </ul>
            </div>
          </td>
          <td *ngIf="platformId == 'br'">
            <select
              formControlName="industry"
              [compareWith]="compareIndustries"
              class="form-select"
            >
              <option *ngFor="let industry of industries" [ngValue]="industry"
                >{{ industry.name | langSelector }}
              </option>
            </select>
          </td>

          <td *ngIf="platformId == 'br'">
            <input
              matInput
              formControlName="country"
              class="table-input form-control"
            />
          </td>
          <td *ngIf="platformId == 'br'">
            <input
              matInput
              formControlName="contactUrl"
              class="table-input form-control"
              style="min-width: 190px;"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <table class="tenant-table">
      <thead>
        <tr>
          <th *ngIf="platformId == 'mx'">
            {{ "master-tenant.tag" | translate }}
          </th>
          <th *ngIf="platformId == 'mx'">
            {{ "master-tenant.industry" | translate }}
          </th>
          <th *ngIf="platformId == 'mx'">
            {{ "master-tenant.subcategory" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td *ngIf="platformId == 'mx'">
            <select
              formControlName="corporationPropertyType"
              class="form-select"
            >
              <option
                *ngFor="let parentCorporationValue of parentCorporationList"
                [ngValue]="parentCorporationValue"
              >
                {{ "PROPERTY_TYPES." + parentCorporationValue | translate }}
              </option>
            </select>
          </td>
          <td *ngIf="platformId == 'mx'">
            <select
              formControlName="industry"
              [compareWith]="compareIndustries"
              class="form-select"
              [attr.disabled]="validateRetail() ? true : null"
            >
              <option *ngFor="let industry of industries" [ngValue]="industry"
                >{{ industry.name | langSelector }}
              </option>
            </select>
          </td>
          <td>
            <select
              formControlName="industryRetail"
              [compareWith]="compareIndustries"
              class="form-select"
              [attr.disabled]="validateCorporationProprerty() ? true : null"
            >
              <option *ngFor="let retail of industryRetails" [ngValue]="retail"
                >{{ retail.name | langSelector }}
              </option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <table *ngIf="platformId == 'mx'" class="tenant-table">
      <thead>
        <tr>
          <th>
            {{ "master-tenant.country" | translate }}
          </th>
          <th>
            {{ "master-tenant.website" | translate }}
          </th>
          <th>{{ "master-tenant.contactName" | translate }}</th>
          <th>{{ "master-tenant.contactPhone" | translate }}</th>
          <th>{{ "master-tenant.contactEmail" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <select formControlName="country" class="form-select">
              <option [ngValue]="null">{{
                "master-tenant.none" | translate
              }}</option>
              <option *ngFor="let country of countries" [ngValue]="country"
                >{{ country | langSelector }}
              </option>
            </select>
          </td>
          <td>
            <input
              matInput
              formControlName="contactUrl"
              class="table-input form-control"
              style="min-width: 190px;"
            />
          </td>
          <td>
            <input
              matInput
              formControlName="contactName"
              class="table-input form-control"
            />
          </td>
          <td>
            <input
              matInput
              formControlName="contactPhone"
              class="table-input form-control"
            />
          </td>
          <td>
            <input
              matInput
              type="date"
              formControlName="contactEmail"
              class="table-input form-control"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button mat-button (click)="close()" class="close-btn">
    {{ "master-tenant.close" | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="tenantForm.invalid"
    class="save-btn"
  >
    {{
      isCreating
        ? ("master-tenant.save" | translate)
        : ("master-tenant.update" | translate)
    }}
  </button>
</mat-dialog-actions>
